export default [
  {
    id: 'checkout-billing-data-company-name',
    name: 'company',
    label: 'smb_acquisition_company_info.fields.company_name.placeholder',
    componentType: 'input',
    columnSize: {
      small: 12,
      medium: 12,
    },
    validations: {
      primitiveType: 'string',
      required: true,
    },
  },
  {
    id: 'checkout-billing-data-zip',
    name: 'zip',
    label: 'smb_acquisition_company_info.fields.address.zip_code.placeholder',
    componentType: 'input',
    columnSize: {
      small: 12,
      medium: 4,
    },
    validations: {
      primitiveType: 'string',
      required: true,
      min: 5,
    },
    options: {
      mask: '*******',
    },
  },
  {
    id: 'checkout-billing-data-street-address',
    name: 'streetAddress',
    label:
      'smb_acquisition_company_info.fields.address.address_line_1.placeholder',
    componentType: 'input',
    columnSize: {
      small: 12,
      medium: 8,
    },
    validations: {
      primitiveType: 'string',
      required: true,
    },
  },
  {
    id: 'checkout-billing-data-complement',
    name: 'complement',
    label:
      'smb_acquisition_company_info.fields.address.address_line_2.placeholder',
    componentType: 'input',
    columnSize: {
      small: 12,
      medium: 8,
    },
    validations: {
      primitiveType: 'string',
      required: false,
    },
  },
  {
    id: 'checkout-billing-data-street-number',
    name: 'streetNumber',
    label:
      'smb_acquisition_company_info.fields.address.street_number.placeholder',
    componentType: 'input',
    columnSize: {
      small: 12,
      medium: 4,
    },
    validations: {
      primitiveType: 'string',
      required: true,
    },
  },
  {
    id: 'checkout-billing-data-state',
    name: 'state',
    label: 'smb_acquisition_company_info.fields.address.state.placeholder',
    componentType: 'select',
    columnSize: {
      small: 12,
      medium: 6,
    },
    items: {
      translation: false,
      defaultElements: {
        insertionMode: 'before', // after, mergeAndSort, clean
        elements: [
          { value: '', name: '' },
          { value: 'South East', name: 'South East' },
          { value: 'London', name: 'London' },
          { value: 'North West', name: 'North West' },
          { value: 'East of England', name: 'East of England' },
          { value: 'West Midlands', name: 'West Midlands' },
          { value: 'South West', name: 'South West' },
          {
            value: 'Yorkshire and the Humber',
            name: 'Yorkshire and the Humber',
          },
          { value: 'East Midlands', name: 'East Midlands' },
          { value: 'North East', name: 'North East' },
        ],
      },
    },
    validations: {
      primitiveType: 'string',
      required: true,
    },
  },
  {
    id: 'checkout-billing-data-city',
    name: 'city',
    label: 'smb_acquisition_company_info.fields.address.city.placeholder',
    componentType: 'input',
    columnSize: {
      small: 12,
      medium: 6,
    },
    validations: {
      primitiveType: 'string',
      required: true,
    },
  },
  {
    id: 'checkout-billing-data-industry',
    name: 'industry',
    label: 'smb_acquisition_form.fields.industry.placeholder',
    componentType: 'select',
    columnSize: {
      small: 12,
      medium: 6,
    },

    items: {
      translation: true,
      defaultElements: {
        insertionMode: 'before', // after, mergeAndSort, clean
        elements: [
          { value: '', name: '' },
          {
            value: 'Agribusiness',
            intlKey:
              'smb_acquisition_form.fields.industry.options.agribusiness',
            name: 'Agribusiness',
          },
          {
            value: 'Airlines',
            intlKey: 'smb_acquisition_form.fields.industry.options.airlines',
            name: 'Airlines',
          },
          {
            value: 'Association',
            intlKey: 'smb_acquisition_form.fields.industry.options.association',
            name: 'Association',
          },
          {
            value: 'Construction',
            intlKey:
              'smb_acquisition_form.fields.industry.options.construction',
            name: 'Construction',
          },
          {
            value: 'Consultancy',
            intlKey: 'smb_acquisition_form.fields.industry.options.consultancy',
            name: 'Consultancy',
          },
          {
            value: 'Consumer Goods',
            intlKey:
              'smb_acquisition_form.fields.industry.options.consumer_goods',
            name: 'Consumer Goods',
          },
          {
            value: 'Education',
            intlKey: 'smb_acquisition_form.fields.industry.options.education',
            name: 'Education',
          },
          {
            value: 'Financial Services',
            intlKey:
              'smb_acquisition_form.fields.industry.options.financial_services',
            name: 'Financial Services',
          },
          {
            value: 'Food and Beverage',
            intlKey:
              'smb_acquisition_form.fields.industry.options.food_and_beverage',
            name: 'Food and Beverage',
          },
          {
            value: 'Government or Public Management',
            intlKey:
              'smb_acquisition_form.fields.industry.options.government_or_public_management',
            name: 'Government or Public Management',
          },
          {
            value: 'Health',
            intlKey: 'smb_acquisition_form.fields.industry.options.health',
            name: 'Health',
          },
          {
            value: 'HR, Staffing and Recruiting',
            intlKey:
              'smb_acquisition_form.fields.industry.options.hr_staffing_and_recruiting',
            name: 'HR, Staffing and Recruiting',
          },
          {
            value: 'Law Firms and Services',
            intlKey:
              'smb_acquisition_form.fields.industry.options.law_firms_and_services',
            name: 'Law Firms and Services',
          },
          {
            value: 'Leisure, Travel and Tourism',
            intlKey:
              'smb_acquisition_form.fields.industry.options.leisure_travel_and_tourism',
            name: 'Leisure, Travel and Tourism',
          },
          {
            value: 'Logistics and Supply Chain',
            intlKey:
              'smb_acquisition_form.fields.industry.options.logistics_and_supply_chain',
            name: 'Logistics and Supply Chain',
          },
          {
            value: 'Manufacturing and Production',
            intlKey:
              'smb_acquisition_form.fields.industry.options.manufacturing_and_production',
            name: 'Manufacturing and Production',
          },
          {
            value: 'Media, Marketing and Advertising',
            intlKey:
              'smb_acquisition_form.fields.industry.options.media_marketing_and_advertising',
            name: 'Media, Marketing and Advertising',
          },
          {
            value: 'Miscellaneous',
            intlKey:
              'smb_acquisition_form.fields.industry.options.miscellaneous',
            name: 'Miscellaneous',
          },
          {
            value: 'NGO/Charity',
            intlKey: 'smb_acquisition_form.fields.industry.options.ngo_charity',
            name: 'NGO/Charity',
          },
          {
            value: 'Pharma',
            intlKey: 'smb_acquisition_form.fields.industry.options.pharma',
            name: 'Pharma',
          },
          {
            value: 'Professional Services',
            intlKey:
              'smb_acquisition_form.fields.industry.options.professional_services',
            name: 'Professional Services',
          },
          {
            value: 'Retail and Wholesale',
            intlKey:
              'smb_acquisition_form.fields.industry.options.retail_and_wholesale',
            name: 'Retail and Wholesale',
          },
          {
            value: 'Self-management',
            intlKey:
              'smb_acquisition_form.fields.industry.options.self_management',
            name: 'Self-management',
          },
          {
            value: 'Technology',
            intlKey: 'smb_acquisition_form.fields.industry.options.technology',
            name: 'Technology',
          },
          {
            value: 'Telecom',
            intlKey: 'smb_acquisition_form.fields.industry.options.telecom',
            name: 'Telecom',
          },
          {
            value: 'Utilities, Energy, and Chemical',
            intlKey:
              'smb_acquisition_form.fields.industry.options.utilities_energy_and_chemical',
            name: 'Utilities, Energy, and Chemical',
          },
        ],
      },
    },
    validations: {
      primitiveType: 'string',
      required: true,
    },
  },
  {
    id: 'checkout-billing-data-company-phone',
    name: 'companyPhone',
    label: 'smb_acquisition_company_info.fields.phone.placeholder',
    componentType: 'input',
    columnSize: {
      small: 12,
      medium: 6,
    },
    options: {
      mask: '(999) 999-9999',
    },
    validations: {
      primitiveType: 'string',
      required: true,
      min: 11,
    },
  },
]
